import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { setLoading } from '../../action/loading-actions'
import { getBaseURL } from '../../lib/util'
import ConnectedAppsList from './list'
import './index.scss'

/**
 * /connected-apps (WEB-7107): the user's connected apps as a page of its own, for links from the consent page,
 * the AI-assistants help page (WEB-7122) and the mobile apps. Like /link and /oauth/consent, the route renders
 * <Login /> in place when signed out, and 'connected-apps' is excluded from the mobile app-store redirect.
 */
const ConnectedAppsPage = ({ setLoading }) => {
  useEffect(() => {
    setLoading(false)
  }, [setLoading])

  return (
    <div className='connected-apps-bg'>
      <div className='connected-apps-card'>
        <h1 className='connected-apps-header'>Connected apps</h1>
        <p className='connected-apps-intro'>
          Apps and AI assistants you&apos;ve allowed to use your BaseMap account.
        </p>
        <ConnectedAppsList />
        <div className='connected-app-actions connected-apps-back'>
          <button className='connected-apps-secondary' onClick={() => { window.location = getBaseURL() }}>
            Back to BaseMap
          </button>
        </div>
      </div>
    </div>
  )
}

const mapDispatchToProps = dispatch => ({
  setLoading: bool => dispatch(setLoading(bool))
})

export default connect(null, mapDispatchToProps)(ConnectedAppsPage)
